import React, { useCallback, useState, useEffect } from 'react';
import { useLocation, useHistory, NavLink, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import Switch from 'react-switch';
import { Modal } from 'react-bootstrap';
import logoSmall from '../../assets/images/lovrican-theme_white-small.svg';
import mobileLogo from '../../assets/images/lovrican-theme_mobile.svg';
import closeImg from '../../assets/images/close.svg';
import AppConstants from '../../appConstants';
import webServices from '../../services/webServices';
import authService from '../../services/authServices';
import NoActivePlanPopup from '../../pages/noActivePlanPopup';
import PlanNotPurchasedPopup from '../../pages/planNotPurchasedPopup';
import { setUser, unsetUser, getUserMatchCount } from '../../redux/actions/user.actions';
import InnerSidebar from './innerSidebar';
import { authCall } from '../../services';
import Section2remainderPopup from '../../pages/section2remainderPopup';
import VerifiedNotificationPopup from '../../pages/verifiedNotificationPopup';
import { PlanBadge } from '../../components/general/ProfileMeta';
import discover from '../../assets/images/header/Discover.svg';
import chat from '../../assets/images/header/Chat.svg';
import myprofile from '../../assets/images/header/My-profile.svg';
// HIDDEN FOR NOW: only the "My Affiliate Account" tab used this icon.
// import affiliate from '../../assets/images/header/Affiliate.svg';
import setting from '../../assets/images/header/settings-white.svg';
import bell from '../../assets/images/header/Bell.svg';
import earning from '../../assets/images/header/Earnings-Grey.svg';
import myAffilliate from '../../assets/images/header/My-affiliate-link-Grey.svg';
import myReferrals from '../../assets/images/header/My-referrals-Grey.svg';
import editProfile from '../../assets/images/header/Edit-Grey.svg';
import aboitAffilliate from '../../assets/images/header/about-affiliates-Grey.svg';
import settingsub from '../../assets/images/header/Settings-Grey.svg';
// FREE MODE (sheet #18): only the Upgrade to Premium button used this icon.
// import managePlan from '../../assets/images/header/Plan-grey.svg';
import matchQueue from '../../assets/images/header/match-queue-Grey.svg';
import matches from '../../assets/images/header/my-matches-Grey.svg';
import myMatches from '../../assets/images/header/New-My-matches-grey.svg';
import prflVisited from '../../assets/images/header/profiles-visited-Grey.svg';
import visitoes from '../../assets/images/header/Visitors.svg';
import paymentHistoryIcon from '../../assets/images/payment-history-grey.svg';
import likeIcon from '../../assets/images/likes-grey.svg';
import roseIcon from '../../assets/images/rose-grey.svg';
import logoGreyIcon from '../../assets/images/lovrican-theme-grey-small.svg';
import whoLikedMe from '../../assets/images/profile-liked-me-grey.svg';
import { encodeData, getQueryParamsObj } from '../../helpers';
import FeedbackModal from './feedbackModal';


// Badge sizing that used to live in an inline style inside an HTML string.
const BADGE_STYLE = { width: '25px', height: '25px', margin: '0 5px' };
const BADGE_CLASS = 'img-fluid verifid_img cursor-pointer';

const CustomSwitchComponent = (props) => {
  const {
    userDetails,
    handleChange,
    userFieldKey,
    fieldKey,
    fieldLabel,
    trueOptionValue,
    falseOptionValue,
    shortDescription,
    onInfoClick
  } = props;

  const switchChangeHandler = selectedVal => handleChange(fieldKey, (selectedVal ? trueOptionValue : falseOptionValue));

  return (
    <div className="sidebar_toggle">


      <div className="custom_switch_private">
        <Switch
          // disabled
          checked={userDetails?.[userFieldKey] === trueOptionValue}
          onChange={switchChangeHandler}
          handleDiameter={20}
          offColor="#d9cbdc"
          onColor="#b800e0"
          offHandleColor="#fff"
          onHandleColor="#fff"
          height={31}
          width={51}
          uncheckedIcon={
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                color: '#fff',
                fontSize: 18,
                fontWeight: 'bold',
                paddingRight: 20,
                paddingTop: 2
              }}
            >
              {/* Off */}
            </div>
          }
          checkedIcon={
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                fontSize: 18,
                fontWeight: 'bold',
                color: '#fff',
                paddingRight: 5,
                paddingTop: 2,
                marginLeft: '35px'
              }}
            >
              {/* On */}
            </div>
          }
          className="react-switch"
        />
      </div>
      <div>
        <div className="head">
          {fieldLabel}
          {onInfoClick && (
            <button
              type="button"
              className="switch-info-btn"
              aria-label={`About ${fieldLabel}`}
              onClick={onInfoClick}
            >
              {/* inline so it takes the label colour; the Adifund info-icon.svg
                  is white and vanishes on this light menu */}
              <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false">
                <circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" strokeWidth="1.5" />
                <circle cx="8" cy="4.9" r="0.9" fill="currentColor" />
                <rect x="7.2" y="6.8" width="1.6" height="5" rx="0.8" fill="currentColor" />
              </svg>
            </button>
          )}
        </div>
        <div className="details">
          <span>{shortDescription}</span>
        </div>
      </div>

    </div>
  );
};

const NotificationWidget = (props) => {
  const { handleRedirect } = props;
  const [notificationData, setNotificationData] = useState({ list: [], unread: 0 });
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const togglePopupVisibility = () => setIsOpen(prevVal => !prevVal);

  const handleDiscoverLinkClick = (evt) => {
    if (location.pathname === AppConstants.routes.afterLogin) {
      evt.preventDefault();
      togglePopupVisibility();
    }
  };

  const getList = async () => {
    const response = await webServices.getNotificationsList();
    if (response?.data) {
      setNotificationData(response?.data);
    }
  };

  useEffect(() => {
    getList();

    const intervalId = setInterval(() => {
      getList();
    }, 1000 * 60);

    return () => clearInterval(intervalId);
  }, []);

  const formatDate = (isoString) => {
    const m = moment(isoString);
    const now = moment();

    if (m.isSame(now, 'day')) {
      return `Today • ${m.format("h:mm a")}`;
    }
    if (m.isSame(now.clone().subtract(1, 'day'), 'day')) {
      return `Yesterday • ${m.format("h:mm a")}`;
    }
    if (m.isSame(now, 'week')) {
      return `${m.format("dddd")} • ${m.format("h:mm a")}`;
    }
    return `${m.format("MMM D, YYYY")} • ${m.format("h:mm a")}`;
  }

  const handleRedirectBtn = async (notificationRow) => {
    const { id: notificationId, action_type: actionType, from_user_id: userId } = notificationRow;

    const encryptedUserId = encodeData(userId);
    togglePopupVisibility();

    await webServices.markNotificationAsRead(notificationId);

    // Check if match exists or not
    if (actionType !== 'message') {
      const result = await webServices.checkIfUserHasMatchWith(userId);
      if (result?.data && result?.data === true) {
        handleRedirect({ redirectTo: AppConstants.routes.matchQueue, queryParams: `?uid=${encryptedUserId}`, checkFor: 'user_unapproved' });
        return;
      }
    }

    if (actionType === 'like_received') {
      handleRedirect({ redirectTo: AppConstants.routes.afterLogin, queryParams: `?q=liked-me&uid=${encryptedUserId}`, checkFor: 'user_unapproved' });
      return;
    }
    if (actionType === 'rose_received') {
      handleRedirect({ redirectTo: AppConstants.routes.afterLogin, queryParams: `?q=liked-me&uid=${encryptedUserId}`, checkFor: 'user_unapproved' });
      return;
    }
    if (actionType === 'profile_match') {
      handleRedirect({ redirectTo: AppConstants.routes.matchQueue, queryParams: `?uid=${encryptedUserId}`, checkFor: 'user_unapproved' });
      return;
    }
    if (actionType === 'profile_view') {
      handleRedirect({ redirectTo: AppConstants.routes.afterLogin, queryParams: `?uid=${encryptedUserId}`, checkFor: 'user_unapproved' });
      return;
    }
    if (actionType === 'message') {
      handleRedirect({ redirectTo: AppConstants.routes.chat, queryParams: `?uid=${encryptedUserId}`, checkFor: 'user_unapproved,no_active_plan' });
    }
  }

  const NotificationRow = ({ rowData }) => {
    const unreadClass = rowData.is_read === 0 ? 'notification-unread' : '';
    // The photo does the same as the row's button (Like / View Profile / ...).
    const avatar = (
      <button type='button' className="profile-img-btn" onClick={() => handleRedirectBtn(rowData)} aria-label={`Open ${rowData['fromUser.user_name']}`}>
        <img src={`${process.env.REACT_APP_PIC_BASE_URL}${rowData['fromUser.profile_image']}`} alt="profile" className="profile-img" />
      </button>
    );

    if (rowData.action_type === 'like_received') {
      return (
        <div className={`notification-item ${unreadClass}`}>
          <span className='bulletPoint' />{avatar}
          <div className="content">
            <p>{rowData['fromUser.user_name']} <span>Liked</span> your Profile</p>
            <div className="time">{formatDate(rowData.created_at)}</div>
            <button type='button' className="btn" onClick={() => handleRedirectBtn(rowData)}>Like</button>
          </div>
        </div>
      );
    }

    if (rowData.action_type === 'rose_received') {
      return (
        <div className={`notification-item ${unreadClass}`}>
          <span className='bulletPoint' />{avatar}
          <div className="content">
            <p>{rowData['fromUser.user_name']} <span> Sent</span> you rose</p>
            <div className="time">{formatDate(rowData.created_at)}</div>
            <button type='button' className="btn" onClick={() => handleRedirectBtn(rowData)}>Send Roses</button>
          </div>
        </div>
      );
    }

    if (rowData.action_type === 'profile_match') {
      return (
        <div className={`notification-item ${unreadClass}`}>
          <span className='bulletPoint' />{avatar}
          <div className="content">
            <p>{rowData['fromUser.user_name']} is now a <span> Match</span></p>
            <div className="time">{formatDate(rowData.created_at)}</div>
            <button type='button' className="btn" onClick={() => handleRedirectBtn(rowData)}>View Profile</button>
          </div>
        </div>
      );
    }

    if (rowData.action_type === 'profile_view') {
      return (
        <div className={`notification-item ${unreadClass}`}>
          <span className='bulletPoint' />{avatar}
          <div className="content">
            <p>{rowData['fromUser.user_name']} <span>Visited</span> your Profile</p>
            <div className="time">{formatDate(rowData.created_at)}</div>
            <button type='button' className="btn" onClick={() => handleRedirectBtn(rowData)}>View Profile</button>
          </div>
        </div>
      );
    }

    // rowData.action_type === 'message'
    return (
      <div className={`notification-item ${unreadClass}`}>
        <span className='bulletPoint' />{avatar}
        <div className="content">
          <p>{rowData['fromUser.user_name']} <span>Sent</span> Your message</p>
          <div className="time">{formatDate(rowData.created_at)}</div>
          <div className="message-box">{rowData.content}</div>
          <button type='button' className="btn" onClick={() => handleRedirectBtn(rowData)}>Go to Chat</button>
        </div>
      </div>
    );
  }

  const NoNotificationRow = () => (
    <>
      <div style={{ padding: '10px 15px', color: '#bababa' }}>    
        <div>No new updates, but your next connection might surprise you!</div>
        <div>Keep exploring in the Discover tab, your next connection could appear any moment!</div>
        <NavLink to={AppConstants.routes.afterLogin} activeClassName="" onClick={handleDiscoverLinkClick}>Go to Discover</NavLink>
      </div>  
    </>
  );

  return (
    <>
      <div className="notification-wrap position-relative mr-3">
        <div onClick={togglePopupVisibility} role="button" className='icon-btn mr-0' tabIndex="0" onKeyDown={() => { }}>
          <img src={bell} alt="" />
          <span className={`badge header-badge ${notificationData.unread < 1 ? 'd-none' : ''}`}>{notificationData.unread}</span>
        </div>

        {isOpen && (
          <div className='notifications'>
            <header className='d-flex justify-between'>
              <h2>Notifications</h2>
              <button type='button' className='btn' onClick={togglePopupVisibility} ds='dfd'>
                <img src={closeImg} alt="close" />
              </button>
            </header>

            <div className='body-notification'>
              {notificationData.list.map((row) => <NotificationRow key={row.id} rowData={row} />)}
              {notificationData.list.length === 0 && (<NoNotificationRow />)}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

const InnerHeader = ({ callBack }) => {
  const dispatch = useDispatch();
  const [userDashSettings, setUserDashSettings] = useState({});
  const [fullName, setFullName] = useState('');
  const [profilePic, setProfilePic] = useState('male-female.png');
  const { pageTitle } = useSelector((state) => state.home);
  const { logout, logoutAffiliate } = authService;
  const history = useHistory();
  // const [matchCount, setMatchCount] = useState(0);
  const [showActivePlan, setShowActivePlan] = useState(false);
  const [showPlanNotPurchased, setShowPlanNotPurchased] = useState({ status: false, popupType: 1 });
  const handleCloseActivePlan = () => setShowActivePlan(false);
  const handleClosePlanNotPurchased = () => setShowPlanNotPurchased({ status: false, popupType: 1 });
  const [menuToggle, setMenuToggle] = useState(false);
  const [showVipInfo, setShowVipInfo] = useState(false);
  const { planDetails, current } = useSelector((state) => state.user);
  const [menuToggle1, setMenuToggle1] = useState(false);
  const [section2RemainderMsg, setSection2RemainderMsg] = useState(false);
  const handleCloseSection2Remainder = () => setSection2RemainderMsg(false);
  const location = useLocation();
  const isAffiliatePage = location.pathname.split('/')[1] === 'affiliate';
  const isAffiliateUser = `${current?.is_affiliate}` === '1';
  const vipModeEnabledBy = current?.vip_mode_enabled_by;

  const [verifyMsg, setVerifyMsg] = useState(false);
  const handleCloseVerifyMsg = () => setVerifyMsg(false);

  const [showFeedbackModal, setShowFeedbackModal] = useState(false);

  const handleClickMenuToggle1 = (status) => {
    setMenuToggle1(status);
  };
  const callbackfunction = () => {
    callBack(true);
  };

  useEffect(async () => {
    setFullName(
      `${current?.first_name || ''} ${current?.last_name || ''}`.trim()
    );
    setProfilePic(current?.profile_image || 'profile_pic.svg');

    const getUserDashSettings = async () => {
      const result = await webServices.getUserDashSettings();
      setUserDashSettings(result.data);
    };

    getUserDashSettings();
  }, [current]);

  const handleClickMenuToggle = (status) => {
    setMenuToggle(status);
  };


  useEffect(async () => {
    setTimeout(() => {
      const activeNavLink = document.querySelector('.subHeader .navbar a.active');
      if (activeNavLink) {
        activeNavLink.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'center'
        });
      }
    }, 0);
  }, []);

  useEffect(async () => {
    dispatch(getUserMatchCount());
  }, []);

  const resetNotificationBadge = async (type) => {
    let key = '';
    if (type === 'profile_match') {
      key = 'profileMatchBadgeCount';
    } else if (type === 'rose_like_received') {
      key = 'likesRosesBadgeCount';
    } else if (type === 'message') {
      key = 'messageBadgeCount';
    } else if (type === 'affiliate_earning') {
      key = 'affiliateEarningBadgeCount';
    }

    if ((userDashSettings[key] ?? 0) > 0) {
      await webServices.resetNotificationBadge(type);
      setUserDashSettings(prevData => ({ ...prevData, [key]: 0 }));
    }
  };

  const handleRedirectChat = async () => {
    const resp = await authCall('user/userCheckPermission', { action: 'chat' });
    if (resp.data === 'profileNotComplete') {
      setMenuToggle(false);
      setSection2RemainderMsg(true);
    } else if (resp.data === 'profileNotApproved') {
      history.push(AppConstants.routes.congratulations);
    } else if (resp.data === 'noActivePlan') {
      setMenuToggle(false);
      setShowActivePlan(true);
    } else if (resp.data === 'planNotPurchased') {
      setMenuToggle(false);
      setShowPlanNotPurchased({ status: true, popupType: (resp.otherData.totalMatchCounts > 0 ? 2 : 1) });
    } else {
      await resetNotificationBadge('message');
      history.push({
        pathname: AppConstants.routes.chat
      });
    }
  };

  const handleRedirectMyMatch = async () => {
    if (current?.status !== 'ACTIVE') {
      history.push(AppConstants.routes.congratulations);
    } else {
      await resetNotificationBadge('profile_match');

      history.push({
        pathname: AppConstants.routes.matchQueue
      });
    }

    // if (current?.status !== 'ACTIVE') {
    //   history.push(AppConstants.routes.congratulations);
    // } else if (userMatchCount > 0) {
    //   history.push({
    //     pathname: AppConstants.routes.matchQueue
    //   });
    // } else {
    //   setMenuToggle(false);
    //   toast.dismiss();
    //   toast.error(
    //     `We haven’t found any matches for you yet. In the meantime, you may update your matching preferences to increase your chances of getting a match.`
    //   );
    //   setTimeout(() => {
    //     history.push({
    //       pathname: AppConstants.routes.afterLogin
    //     });
    //   }, 3000);
    // }
  };

  const isProfileLinkActive = useCallback(
    (match, { pathname }) =>
      [AppConstants.routes.publicProfile].includes(pathname),
    []
  );
  const isMatchQueueLinkActive = useCallback((match, { pathname }) => {
    const paramsObj = getQueryParamsObj(location.search);
    const totalParams = Object.keys(paramsObj).length;
    const uidParam = paramsObj?.uid ?? null;
    const uidParamStr = (uidParam && totalParams === 1) || totalParams === 0 ? `?uid=` : '';
    return [`${AppConstants.routes.afterLogin}?uid=`].includes(`${pathname}${uidParamStr}`);
  }, [location]);

  const isSettingLinkActive = useCallback((match, { pathname }) =>
    [AppConstants.routes.settings].includes(pathname)
  );

  const isChatLinkActive = useCallback((match, { pathname }) =>
    [AppConstants.routes.chat].includes(pathname)
  );

  const isMyMatchLinkActive = useCallback((match, { pathname }) =>
    [AppConstants.routes.matchQueue].includes(pathname)
  );

  const isDashboardLinkActive = useCallback(
    (match, { pathname }) =>
      [AppConstants.routes.affiliate.dashboard].includes(pathname),
    []
  );
  const isReferalLinkActive = useCallback(
    (match, { pathname }) =>
      [AppConstants.routes.affiliate.referals].includes(pathname),
    []
  );
  const isEarningsLinkActive = useCallback(
    (match, { pathname }) =>
      [AppConstants.routes.affiliate.earnings].includes(pathname),
    []
  );
  const isAffiliateProfileLinkActive = useCallback(
    (match, { pathname }) =>
      [AppConstants.routes.affiliate.profile].includes(pathname),
    []
  );
  /* HIDDEN FOR NOW: only the side-menu "Affiliate Service" links used these.
  const isAffiliateSettingLinkActive = useCallback((match, { pathname }) =>
    [AppConstants.routes.affiliate.settings].includes(pathname)
  );
  const isContactUsLinkActive = useCallback((match, { pathname }) =>
    [AppConstants.routes.affiliate.contactsUs].includes(pathname)
  );
  */

  const handleDatingServiceClickEvt = (evt) => {
    if (isAffiliateUser && current?.is_affiliate_dating_profile_completed !== 'YES') {
      evt.preventDefault();
      evt.stopPropagation();

      window.localStorage.setItem('show_affiliate_profile_incomplete_form', 'YES');

      history.push(AppConstants.routes.registerSections);
    }
  }

  const handleClickLogo = (evt) => {
    if (isAffiliatePage) {
      history.push(AppConstants.routes.affiliate.dashboard);
    } else {
      handleRedirectMyMatch(evt);
    }
  }

  const handleSwitchChange = async (fieldKey, fieldValue) => {
    webServices
      .updateUserDetails(current.id, { [fieldKey]: fieldValue })
      .then((response) => {
        if (response && response.success) {
          dispatch(setUser(response.data));
        }
        return response;
      });
  };

  const isDiscoverTabActive = (pathname) => [AppConstants.routes.afterLogin, AppConstants.routes.matchQueue].includes(pathname);
  const isDiscoverLinkActive = useCallback((match, { pathname }) => isDiscoverTabActive(pathname), []);

  const isMatchQueueVisitorsLinkActive = useCallback((match, { pathname }) => [`${AppConstants.routes.afterLogin}?q=visitors`].includes(`${pathname}${location.search}`), [location]);
  const isMatchQueueVisitedLinkActive = useCallback((match, { pathname }) => [`${AppConstants.routes.afterLogin}?q=visited`].includes(`${pathname}${location.search}`), [location]);
  const isMatchQueueLikedLinkActive = useCallback((match, { pathname }) => [`${AppConstants.routes.afterLogin}?q=liked`].includes(`${pathname}${location.search}`), [location]);
  const isMatchQueueRosesLinkActive = useCallback((match, { pathname }) => [`${AppConstants.routes.afterLogin}?q=send-roses`].includes(`${pathname}${location.search}`), [location]);
  const isMatchQueueLikeReceivedLinkActive = useCallback((match, { pathname }) => {
    const qParam = getQueryParamsObj(location.search)?.q ?? '';
    return [`${AppConstants.routes.afterLogin}?q=liked-me`].includes(`${pathname}?q=${qParam}`)
  }, [location]);

  const isMyProfileTabActive = (pathname) => [
    AppConstants.routes.publicProfile,
    AppConstants.routes.settings
  ].includes(pathname);
  const isMyProfileLinkActive = useCallback((match, { pathname }) => isMyProfileTabActive(pathname), []);

  const isPlansTabActive = (pathname) => [
    AppConstants.routes.plansView,
    AppConstants.routes.plans,
    AppConstants.routes.rosePlans,
    AppConstants.routes.likesPlans,
    AppConstants.routes.billingDetails,
    AppConstants.routes.roseHistory,
    AppConstants.routes.likeHistory
  ].includes(pathname);
  // FREE MODE (sheet #18): only the Upgrade to Premium button used this.
  // const isPlansLinkActive = useCallback((match, { pathname }) => isPlansTabActive(pathname), []);

  const isSubscriptionPlansLinkActive = useCallback((match, { pathname }) => [AppConstants.routes.plans].includes(pathname));
  const isRosePlansLinkActive = useCallback((match, { pathname }) => [AppConstants.routes.rosePlans].includes(pathname));
  const isLikePlansLinkActive = useCallback((match, { pathname }) => [AppConstants.routes.likesPlans].includes(pathname));
  const isPaymentHistoryLinkActive = useCallback((match, { pathname }) => [
    AppConstants.routes.billingDetails,
    AppConstants.routes.roseHistory,
    AppConstants.routes.likeHistory
  ].includes(pathname));

  const isAffiliateTabActive = (pathname) => [
    AppConstants.routes.affiliate.earnings,
    AppConstants.routes.affiliate.dashboard,
    AppConstants.routes.affiliate.referals,
    AppConstants.routes.affiliate.profile
  ].includes(pathname);
  /* HIDDEN FOR NOW: only the "My Affiliate Account" tab used this.
  const isAffiliateLinkActive = useCallback((match, { pathname }) => isAffiliateTabActive(pathname), []);
  */

  const handleRedirect = async ({ redirectTo, queryParams = '', checkFor = null, notiType = '' }) => {
    const checkForArr = (checkFor ?? '').split(',');

    // eslint-disable-next-line no-restricted-syntax
    for await (const checkForVal of checkForArr) {
      if (checkForVal === 'user_unapproved' && current?.status !== 'ACTIVE') {
        history.push(AppConstants.routes.congratulations);
        return;
      }
      if (checkForVal === 'no_active_plan' && current?.isPlanExpired === true) {
        await handleRedirectChat();
        return;
      }
    }

    await resetNotificationBadge(notiType);

    history.push({
      pathname: redirectTo,
      search: queryParams
    });
  }

  return (
    <>
      <div className="innerHeader mobile">

        <div className="mobile-menu d-none" onClick={callbackfunction} aria-hidden="true" >
          <i className="fa fa-bars" aria-hidden="true" />
        </div>

        <header className="d-flex align-items-center">
          <div className=" text-md-left text-center mobile-top">
            <div className='d-flex'>
              <div className="desktop-menu">
                <div
                  className="burger"
                  aria-hidden="true"
                  onClick={() => handleClickMenuToggle(!menuToggle)}
                >
                  <span />
                  <span />
                  <span />
                </div>
              </div>
              <Link onClick={handleClickLogo} to="#0" className="logo-db w-100">
                <img src={logoSmall} className="img-fluid" alt="Lovrican Logo" />
              </Link>
            </div>
          </div>

          <nav className="navbar">
            <NavLink to={AppConstants.routes.afterLogin} activeClassName="active" isActive={isDiscoverLinkActive}>
              <img src={discover} alt="" /> <span className='head'> Matches</span> <span className='head_mobile'> Matches</span>
            </NavLink>
            <button type='button' className='formate1' onClick={handleRedirectChat} aria-hidden="true">
              <NavLink to="#0" activeClassName="active" isActive={isChatLinkActive}>
                <div className='badge-wrap'>
                  <img src={chat} alt="" />
                  <span className={`badge header-badge ${!userDashSettings?.messageBadgeCount ? 'd-none' : ''}`}>{userDashSettings?.messageBadgeCount}</span>
                </div>
                <span className='head'>Chat</span>
                <span className='head_mobile'>Chat</span>
              </NavLink>
            </button>
            <NavLink to={AppConstants.routes.publicProfile} activeClassName="active" isActive={isMyProfileLinkActive}>
              <img src={myprofile} alt="" /> <span className='head'>My Profile</span> <span className='head_mobile'>My Profile</span>
            </NavLink>
            {/* FREE MODE: the app is 100% free — no Plans tab. */}
            {/* HIDDEN FOR NOW: the "My Affiliate Account" tab is switched off
                until affiliates are shown again. Restore by uncommenting this
                block and `isAffiliateLinkActive` above.
            {isAffiliateUser && (
              <NavLink className="last" to={AppConstants.routes.affiliate.dashboard} activeClassName="active" isActive={isAffiliateLinkActive}>
                <img src={affiliate} alt="" />
                <span className={`badge header-badge ${!userDashSettings?.affiliateEarningBadgeCount ? 'd-none' : ''}`}>{userDashSettings?.affiliateEarningBadgeCount}</span>
                <span className='head'>My Affiliate Account</span>
                <span className='head_mobile'>Earning</span>
              </NavLink>
            )}
            */}
          </nav>

          <div className="righbar">
            {/* FREE MODE (releases sheet #18): "Upgrade to Premium" is switched
                off while membership is free. Restore by uncommenting this block,
                the managePlan import and isPlansLinkActive above.
            {current?.isPlanExpired === true && (
              <button type='button' className='nav-item upgrade_wrapper' onClick={() => handleRedirect({ redirectTo: AppConstants.routes.plans, checkFor: 'user_unapproved' })}>
                <NavLink to="#0" className='nav-item upgrade-btn' activeClassName="active" isActive={isPlansLinkActive}>
                  <img src={managePlan} alt="" />  <span className='head'>Upgrade to Premium</span> <span className='head_mobile'>Plans</span>
                </NavLink>
              </button>
            )}
            */}

            <NotificationWidget handleRedirect={handleRedirect} />

            <NavLink to={AppConstants.routes.settings} className="icon-btn right-icon-btn"><img src={setting} alt="" /></NavLink>

            <Link to={AppConstants.routes.publicProfile} className="profile-img-link" title="Edit profile">
              <img src={process.env.REACT_APP_PIC_BASE_URL + profilePic} alt="Profile Img" className="profile-img" />
            </Link>
          </div>

          <div className=" text-md-right d-none">
            {/* this is old code and hide by css start */}
            <div className="d-flex justify-content-end align-items-center">
              <div className="d-flex">
                {pageTitle === 'Match Queue' && (
                  <div className="text-md-right desktop-only">
                    <div className="likeToday">
                      <div className="numeric">
                        {planDetails.dailyLikeLimit}
                      </div>
                      <span>likes left today</span>
                    </div>
                  </div>
                )}
                <div className="profileSection position-relative">
                  <span>
                    <PlanBadge
                      user={current}
                      iconOnly
                      className={BADGE_CLASS}
                      style={BADGE_STYLE}
                    />
                  </span>
                  <span className="frfl_name" title={fullName}>
                    {fullName}
                  </span>
                  <Link
                    to={isAffiliateUser && vipModeEnabledBy === 'user' ? AppConstants.routes.affiliate.profile : AppConstants.routes.publicProfile}
                    className="logo-db"
                  >
                    <img
                      src={process.env.REACT_APP_PIC_BASE_URL + profilePic}
                      className="img-fluid d-inline-block"
                      alt=" profile img"
                    />
                  </Link>
                  <span className="active" />
                </div>
              </div>

              <div className="three_dot">
                <div
                  className="toggle-icon"
                  aria-hidden="true"
                  onClick={() => handleClickMenuToggle1(!menuToggle1)}
                >
                  <span />
                  <span />
                  <span />
                </div>
                {menuToggle1 && <InnerSidebar />}
              </div>
            </div>
            {/* this is old code and hide by css end */}
          </div>

        </header>

        {/* New Navbar */}
        <div className={`subHeader ${isDiscoverTabActive(location.pathname) || isMyProfileTabActive(location.pathname) || isAffiliateTabActive(location.pathname) || isPlansTabActive(location.pathname) ? '' : 'd-none'}`}>
          <nav className={`navbar ${isDiscoverTabActive(location.pathname) ? '' : 'd-none'}`}>
            <button type='button' className='nav-item formate2'>
              <NavLink to={AppConstants.routes.afterLogin} className='nav-item' activeClassName="active" isActive={isMatchQueueLinkActive}>
                <div className='badge-wrap'>
                  <img src={matchQueue} alt="" />
                </div> Discover
              </NavLink>
            </button>
            <button type='button' className='nav-item formate2' onClick={handleRedirectMyMatch}>
              <NavLink to="#0" className='nav-item' activeClassName="active" isActive={isMyMatchLinkActive}>
                <div className='badge-wrap'>
                  <img src={myMatches} alt="" />
                  <span className={`badge header-badge ${!userDashSettings?.profileMatchBadgeCount ? 'd-none' : ''}`}>{userDashSettings?.profileMatchBadgeCount}</span>
                </div>
                My matches
              </NavLink >
            </button >
            {userDashSettings?.profileWhoLikedMe && (
              <button type='button' className='nav-item formate2' onClick={() => handleRedirect({ redirectTo: AppConstants.routes.afterLogin, queryParams: '?q=liked-me', checkFor: 'user_unapproved', notiType: 'rose_like_received' })}>
                <NavLink to="#0" className='nav-item' activeClassName="active" isActive={isMatchQueueLikeReceivedLinkActive}>
                  <img src={whoLikedMe} alt="" /> {current?.gender === 'MAN' ? 'Women' : 'Men'} who liked me
                  <span className={`badge header-badge ${!userDashSettings?.likesRosesBadgeCount ? 'd-none' : ''}`}>{userDashSettings?.likesRosesBadgeCount}</span>
                </NavLink>
              </button>
            )}
            {userDashSettings?.likedProfiles && (
              <button type='button' className='nav-item formate2' onClick={() => handleRedirect({ redirectTo: AppConstants.routes.afterLogin, queryParams: '?q=liked', checkFor: 'user_unapproved' })}>
                <NavLink to="#0" className='nav-item' activeClassName="active" isActive={isMatchQueueLikedLinkActive}>
                  <img src={matches} alt="" /> Profile I liked
                </NavLink>
              </button>
            )}
            {userDashSettings?.rosesSend && (
              <button type='button' className='nav-item formate2' onClick={() => handleRedirect({ redirectTo: AppConstants.routes.afterLogin, queryParams: '?q=send-roses', checkFor: 'user_unapproved' })}>
                <NavLink to="#0" className='nav-item' activeClassName="active" isActive={isMatchQueueRosesLinkActive}>
                  <img src={roseIcon} alt="" /> Roses I sent
                </NavLink>
              </button>
            )}
            {userDashSettings?.profileVisits && (
              <button type='button' className='nav-item formate2' onClick={() => handleRedirect({ redirectTo: AppConstants.routes.afterLogin, queryParams: '?q=visitors', checkFor: 'user_unapproved' })}>
                <NavLink to="#0" className='nav-item' activeClassName="active" isActive={isMatchQueueVisitorsLinkActive}>
                  <img src={visitoes} alt="" /> Visitors to my profile
                </NavLink>
              </button>
            )}
            {userDashSettings?.visitedProfiles && (
              <button type='button' className='nav-item formate2' onClick={() => handleRedirect({ redirectTo: AppConstants.routes.afterLogin, queryParams: '?q=visited', checkFor: 'user_unapproved' })}>
                <NavLink to="#0" className='nav-item' activeClassName="active" isActive={isMatchQueueVisitedLinkActive}>
                  <img src={prflVisited} alt="" /> Profiles I have visited
                </NavLink>
              </button>
            )}
          </nav >

          {/* My Profile */}
          < nav className={`navbar ${isMyProfileTabActive(location.pathname) ? '' : 'd-none'}`}>
            <NavLink to={AppConstants.routes.publicProfile} className="nav-item" activeClassName="active" isActive={isProfileLinkActive}>
              <img src={editProfile} alt="" />  Edit profile
            </NavLink>
            <NavLink to={AppConstants.routes.settings} className="nav-item" activeClassName="active" isActive={isSettingLinkActive}>
              <img src={settingsub} alt="" /> Account settings
            </NavLink>
          </nav >

          {/* Plans */}
          < nav className={`navbar ${isPlansTabActive(location.pathname) ? '' : 'd-none'}`}>
            <NavLink to={AppConstants.routes.plans} className="nav-item" activeClassName="active" isActive={isSubscriptionPlansLinkActive}>
              <img src={logoGreyIcon} alt="" />  Subscription Plans
            </NavLink>
            <NavLink to={AppConstants.routes.rosePlans} className="nav-item" activeClassName="active" isActive={isRosePlansLinkActive}>
              <img src={roseIcon} alt="" /> Rose Plans
            </NavLink>
            <NavLink to={AppConstants.routes.likesPlans} className="nav-item" activeClassName="active" isActive={isLikePlansLinkActive}>
              <img src={likeIcon} alt="" /> Like Plans
            </NavLink>
            <NavLink to={AppConstants.routes.billingDetails} className="nav-item" activeClassName="active" isActive={isPaymentHistoryLinkActive}>
              <img src={paymentHistoryIcon} alt="" /> Payment History
            </NavLink>
          </nav >

          {/* Affiliate */}
          {isAffiliateUser && (
            <nav className={`navbar ${isAffiliateTabActive(location.pathname) ? '' : 'd-none'}`}>
              <NavLink to={AppConstants.routes.affiliate.dashboard} className="nav-item" activeClassName="active" isActive={isDashboardLinkActive}>
                <img src={myAffilliate} alt="" /> My affiliate link
              </NavLink>
              <button type='button' className='nav-item formate2' onClick={() => handleRedirect({ redirectTo: AppConstants.routes.affiliate.earnings, notiType: 'affiliate_earning' })}>
                <NavLink to="#0" className='nav-item' activeClassName="active" isActive={isEarningsLinkActive}>
                  <img src={earning} alt="" /> My earnings
                  <span className={`badge header-badge ${!userDashSettings?.affiliateEarningBadgeCount ? 'd-none' : ''}`}>{userDashSettings?.affiliateEarningBadgeCount}</span>
                </NavLink>
              </button>
              <NavLink to={AppConstants.routes.affiliate.referals} className="nav-item" activeClassName="active" isActive={isReferalLinkActive}>
                <img src={myReferrals} alt="" /> My referrals
              </NavLink>
              <NavLink to={AppConstants.routes.affiliate.profile} className="nav-item" activeClassName="active" isActive={isAffiliateProfileLinkActive}>
                <img src={editProfile} alt="" /> My profile
              </NavLink>
              <NavLink to={AppConstants.routes.affiliate.home} className="nav-item" target="_blank" rel="noopener noreferrer" activeClassName="">
                <img src={aboitAffilliate} alt="" /> About affiliates
              </NavLink>
            </nav>
          )}
        </div >
      </div >
      {/* mobile menu start */}
      < div className="mobile-view-inner" >
        <div
          className="burger"
          aria-hidden="true"
          onClick={() => handleClickMenuToggle(!menuToggle)}
        >
          <span />
          <span />
          <span />
        </div>
        <div className="logo-mobile" role="button">
          <Link to="/match-queue" className="logo-db">
            <img src={mobileLogo} className="img-fluid" alt="Lovrican Logo" />
          </Link>
        </div>
      </div >

      <div className={`navbar-mobile inner_menu ${menuToggle ? 'block' : 'd-none'}`}>
        <div className="menu-wrapper">

          <div className="header">
            <h2>Our Services:</h2>
            <button
              type="button"
              className="close"
              onClick={() => setMenuToggle(false)}
            >
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close</span>
            </button>
          </div>
          <div className='menu_body'>
            <div className='sub_head'>Find your special African soulmate</div>

            {/* FREE MODE: every member is premium now that the paid plans are
                gone, so VIP Privacy Mode is no longer gated on plan 11. Old
                gate kept for reversal:
                {current.currentPlanId === 11 && current?.isPlanExpired !== true && ( ... )} */}
            <CustomSwitchComponent
              key='vip_mode_switch'
              userDetails={current}
              handleChange={handleSwitchChange}
              userFieldKey='is_vip_mode_enabled'
              fieldKey='isVipModeEnabled'
              fieldLabel='VIP Privacy Mode'
              trueOptionValue={1}
              falseOptionValue={0}
              shortDescription='Make my profile invisible to all except those I like / match with'
              onInfoClick={() => setShowVipInfo(true)}
            />

            <CustomSwitchComponent
              key='private_mode_switch'
              userDetails={current}
              handleChange={handleSwitchChange}
              userFieldKey='is_profile_private'
              fieldKey='isProfilePrivate'
              fieldLabel='Private profile feature'
              trueOptionValue='YES'
              falseOptionValue='NO'
              shortDescription='(Blur my photo, hide my city)'
            />

            <div className='dating_service_wrapper'>
              {/* Releases sheet #23: the "Dating Service" accordion is gone and
                  its links render directly. The affiliate "complete your dating
                  profile first" redirect that lived on the accordion button now
                  runs on the list itself. Old markup kept for reversal:
              <button type='button' className='collapse_btn primary collapsed' data-toggle="collapse" data-target="#service1" aria-expanded="false" onClick={evt => handleDatingServiceClickEvt(evt)}>
                <span className='name'>Dating Service</span>
                <span><i className="fa fa-plus" /><i className="fa fa-minus" /></span>
              </button>
              <div id="service1" className='collapse_body collapse'>
              */}
              <div
                id="service1"
                className='collapse_body dating_service_links'
                onClickCapture={handleDatingServiceClickEvt}
              >
                <div className="card card-body">
                  <ul className="list-unstyled">
                    <li onClick={handleRedirectMyMatch} aria-hidden="true">
                      <NavLink to="#0" activeClassName="active" isActive={isMyMatchLinkActive}>My Matches</NavLink>
                    </li>
                    <li onClick={handleRedirectChat} aria-hidden="true">
                      <NavLink to="#0" activeClassName="active" isActive={isChatLinkActive}>Chat</NavLink>
                    </li>
                    <li>
                      <NavLink to={AppConstants.routes.afterLogin} activeClassName="active" isActive={isMatchQueueLinkActive}>Discover</NavLink>
                    </li>
                    <li>
                      <NavLink to={AppConstants.routes.publicProfile} activeClassName="active" isActive={isProfileLinkActive}>Profile</NavLink>
                    </li>
                    <li>
                      <NavLink to={AppConstants.routes.settings} activeClassName="active" isActive={isSettingLinkActive}>Settings</NavLink>
                    </li>
                    {/* FREE MODE: the app is 100% free — no Plans link. */}
                  </ul>
                </div>
              </div>

              {/* HIDDEN FOR NOW: the "Affiliate Service" section of the side
                  menu is switched off until affiliates are shown again.
                  Restore by uncommenting this block.
              {isAffiliateUser && (
                <>
                  <div className='divider' />
                  <div className='sub_head'>Make money with Lovrican</div>
                  <button type='button' className="collapse_btn secondry collapsed" data-toggle="collapse" data-target="#service2" aria-expanded="false">
                    <span className='name'>Affiliate Service</span>
                    <span><i className="fa fa-plus" /><i className="fa fa-minus" /></span>
                  </button>
                  <div id="service2" className="collapse_body collapse">
                    <div className="card card-body">
                      <ul className="list-unstyled">
                        <li>
                          <NavLink to={AppConstants.routes.affiliate.dashboard} activeClassName="active" isActive={isDashboardLinkActive}>Dashboard</NavLink>
                        </li>
                        <li>
                          <NavLink to={AppConstants.routes.affiliate.home} target="_blank" rel="noopener noreferrer" activeClassName="">About Affiliates</NavLink>
                        </li>
                        <li>
                          <NavLink to={AppConstants.routes.affiliate.referals} activeClassName="active" isActive={isReferalLinkActive}>Referrals</NavLink>
                        </li>
                        <li>
                          <NavLink to={AppConstants.routes.affiliate.earnings} activeClassName="active" isActive={isEarningsLinkActive}>Earnings</NavLink>
                        </li>
                        <li>
                          <NavLink to={AppConstants.routes.affiliate.profile} activeClassName="active" isActive={isAffiliateProfileLinkActive}>Profile</NavLink>
                        </li>
                        <li>
                          <NavLink to={AppConstants.routes.affiliate.settings} activeClassName="active" isActive={isAffiliateSettingLinkActive}>Settings</NavLink>
                        </li>
                        <li>
                          <NavLink to={AppConstants.routes.affiliate.contactsUs} activeClassName="active" isActive={isContactUsLinkActive}>Contact us</NavLink>
                        </li>
                      </ul>
                    </div>
                  </div>
                </>
              )}
              */}
            </div>
          </div>

          <div className='footer'>
            <div className="d-block link-btn">
              <span
                className="round-button mt-0"
                role="button"
                aria-hidden="true"
                onClick={() => {
                  if (isAffiliatePage) {
                    logoutAffiliate(history);
                  } else {
                    logout(history);
                  }
                  dispatch(unsetUser());
                }}
              >
                Logout
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* mobile menu End */}

      <div className="mobile-only">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-8">
              <div className="d-flex left align-items-center">
                <span className="active mr-2" />
                <span className="profile-name-mbl">{fullName}</span>
                <span>
                  <PlanBadge
                    user={current}
                    iconOnly
                    className={BADGE_CLASS}
                    style={BADGE_STYLE}
                  />
                </span>
              </div>
            </div>
            <div className="col-4">
              <div className="d-flex left align-items-center justify-content-end">
                {pageTitle === 'Match Queue' && (
                  <div className="mbl-like">
                    <div className="num_like">{planDetails.dailyLikeLimit}</div>
                    <div>Likes left today</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='feedback-wrap'>
        <button type='button' className='feedback-btn' onClick={() => setShowFeedbackModal(true)}>FEEDBACK</button>
      </div>

      <NoActivePlanPopup
        modalStatus={showActivePlan}
        handleClose={handleCloseActivePlan}
        currentPlan={planDetails}
      />

      <PlanNotPurchasedPopup
        modalStatus={showPlanNotPurchased.status}
        handleClose={handleClosePlanNotPurchased}
        popupType={showPlanNotPurchased.popupType}
      />

      <Section2remainderPopup
        modalStatus={section2RemainderMsg}
        handleClose={handleCloseSection2Remainder}
        userDetails={current}
      />

      <VerifiedNotificationPopup
        modalStatus={verifyMsg}
        handleClose={handleCloseVerifyMsg}
        userDetails={current}
      />

      <FeedbackModal show={showFeedbackModal} handleClose={() => setShowFeedbackModal(false)} />
      {/* Releases sheet #24/#25 — what VIP Privacy Mode does */}
      <Modal
        className="feedback_modal vip-info-modal"
        show={showVipInfo}
        onHide={() => setShowVipInfo(false)}
        centered
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="w-100 text-center text-purple fw-bold">
            VIP Privacy Mode
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="vip-info-lead">Ultra VIP privacy, free for every Lovrican member.</p>
          <ul className="vip-info-list">
            <li>Stealth mode. Your profile is completely private (no one can see your profile by default).</li>
            <li>Only people whose profiles you like will see your profile.</li>
            <li>Even then your name, photo, and city are invisible until you match with someone.</li>
            <li>5 Free Roses each month ($5 value), so that you can date like a true VIP.</li>
          </ul>
        </Modal.Body>
      </Modal>

    </>
  );
};

export default InnerHeader;
